import {
  type PreviewRequirementItem,
  type PreviewRequirements,
} from "../content/preview-details.types";
const workingLocallySentencePattern = /Working locally needs[^.]*\./;
const canonicalRequirementsSentencePattern =
  /^Working locally needs `uv` and Docker; the `coworld` CLI ships as the `coworld\[auth\]` package/;
const canonicalRequirementItems: readonly PreviewRequirementItem[] = [
  {
    name: "uv",
    purpose: "the Python tool that installs and runs the coworld CLI",
  },
  {
    name: "Docker",
    purpose:
      "runs the game and your player locally; on macOS use OrbStack or Colima",
  },
];
function parseWorkingLocallyRequirements(
  guide: string,
): PreviewRequirementItem[] {
  const sentence = workingLocallySentencePattern.exec(guide)?.[0];

  if (!sentence) return [];

  if (canonicalRequirementsSentencePattern.test(sentence)) {
    return [...canonicalRequirementItems];
  }

  return sentence
    .replace(/^Working locally needs\s*/, "")
    .split(/,\s*(?:and\s+)?|\s+and\s+|;\s*/)
    .map((fragment) =>
      fragment
        .replaceAll("`", "")
        .replace(/\.\s*$/, "")
        .trim(),
    )
    .filter(Boolean)
    .map((name) => ({ name, purpose: "" }));
}
export function requirementsFrom(guide: string): PreviewRequirements | null {
  const items = parseWorkingLocallyRequirements(guide);
  return items.length === 0 ? null : { items };
}
